<template>
  <button v-for="(show, index) in showTime" :key="index" :data-toggle="show.isonline == 0&&loginCode ?'':show.isonline == 0? 'modal' : 'modal'"
    :data-target="show.isonline == 0&&loginCode?'':show.isonline==0?'#largeModal':'#smallmodal'" class="tim goScreen bg4 text-center tibtn"
    :style="$route.params.showid == show.id ? { 'background-color': '552727' } : { 'background-color': fillColor(show.booked, show.seats, show.isonline) }"
    @click="selected(show.id,show.isonline)">
    <span class="linht">
      {{ show.stime }}
      <div class="scnb">{{ show.screen }}</div>

      <div class="spck">{{ show.exp }}</div>
    </span></button>

</template>

<script>
// import RegisterUser from '../GetStarted/RegisterUser.vue';
export default {
  data:()=>({
    loginCode:localStorage.getItem("loginCode"),
  }),
  props: ['showTime'],

  methods: {
    selected(showid,ison) {
      this.$emit('showselected',showid,ison);
      if(this.loginCode&&ison==0){
        
        this.$router.push({
        path: "../seatlayout/" + showid
      });
      }
    },
    fillColor(cnt, seats, ison) {   
      if (ison != 0) {
        return 'rgb(204,204,204)';
      }
      var blprc = cnt / seats;
      var r = 233;
var g = Math.floor(233 * (1 - blprc) + 17 * blprc);
var b = Math.floor(237 * (1 - blprc) + 0 * blprc);
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    }
  },
created(){
}
};
</script>
